// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldGroup-container {
  padding: 10px;
}
.fieldGroup-container .fieldGroup-title {
  padding: 10px 20px;
  -webkit-user-select: none;
          user-select: none;
  font-weight: bold;
}
.fieldGroup-container .fieldGroup-title-expandable {
  padding: 10px;
  border-radius: 5px;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F5F9FF;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/FieldGroup/FieldGroup.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD;AACC;EACC,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;AACF;AAEC;EACC,aAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,iBAAA;AAAF","sourcesContent":[".fieldGroup-container {\n\tpadding: 10px;\n\n\t.fieldGroup-title {\n\t\tpadding: 10px 20px;\n\t\tuser-select: none;\n\t\tfont-weight: bold;\n\t}\n\n\t.fieldGroup-title-expandable {\n\t\tpadding: 10px;\n\t\tborder-radius: 5px;\n\t\tuser-select: none;\n\t\tbackground-color: #F5F9FF;\n\t\tfont-weight: bold;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
